// extracted by mini-css-extract-plugin
export default {"mainContainer":"NavBar_mainContainer__--9h4","botonHome":"NavBar_botonHome__UCH-J","botonActivities":"NavBar_botonActivities__pPqb9","botonForm":"NavBar_botonForm__8VWp5"};